"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_helmet_1 = require("react-helmet");

function Algolia(_a) {
  var id = _a.id,
      apiKey = _a.apiKey,
      indexName = _a.indexName,
      debug = _a.debug,
      children = _a.children;
  react_1.useEffect(function () {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cdn.jsdelivr.net/npm/docsearch.js@2/dist/cdn/docsearch.min.js';
    document.head.appendChild(script);

    script.onload = function () {
      // @ts-ignore
      window.docsearch({
        apiKey: apiKey,
        indexName: indexName,
        inputSelector: "#" + id,
        debug: debug
      });
    };
  }, []);
  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(react_helmet_1.Helmet, null, react_1["default"].createElement("link", {
    key: "algolia-search",
    rel: "stylesheet",
    href: "https://cdn.jsdelivr.net/npm/docsearch.js@2/dist/cdn/docsearch.min.css"
  })), children);
}

exports.Algolia = Algolia;